import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 90vw;
  max-width: 900px;
`

export const IframeWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 aspect ratio */

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 8px;
  }
`
